import { getData } from './api'
import { Post, Get } from './saasapi'
import { getToken } from '@/utils/auth'

export function login (data) {
  return Post('Shuangquan.DealerManagement.Admin.Base.Distributor', 'distributor/Login', data)
}

export function doGjgLoginEx (data) {
  return Post('Shuangquan.DealerManagement.Admin.Base.Distributor', 'distributor/doLoginFormExternalID', data)
}

export function doGjgLogin (data) {
  return Post('Shuangquan.DealerManagement.Admin.Base.Distributor', 'distributor/doLoginFormGJGKey', data)
}

export function getInfo (data) {
  return Get('Shuangquan.DealerManagement.Admin.Base.Distributor', 'distributor/getguid', getToken())
}

export function logout () {
  return getData('logout', {})
}



// WEBPACK FOOTER //
// ./src/api/user.js